// extracted by mini-css-extract-plugin
export default {"tabclix_donation_button":"donationButton_tabclix_donation_button__txMr1","button":"donationButton_button__NWUAL"};